import React, { useEffect, useState } from "react";
import "./AnalogClock.css";

/* ✅ IMPORT YOUR PNG ICONS */
import aiIntegration from "../assets/AI integration.png";
import seo from "../assets/SEO.png";
import websiteDesign from "../assets/website icon.png";
import emailMarketing from "../assets/Email marketing.png";
import onlinePR from "../assets/Online PR.png";
import socialMedia from "../assets/Social media.png";
import blogging from "../assets/Blogging.png";
import multimedia from "../assets/Multimedia.png";
import ppc from "../assets/Pay per click ads.png";
import displayAds from "../assets/Display ads.png";
import webContent from "../assets/Web content.png";
import cyberSecurity from "../assets/Cyber security.png";

const SERVICES = [
  { key: "seo", angle: -90, icon: seo, alt: "SEO" },
  { key: "webdesign", angle: -60, icon: websiteDesign, alt: "Website Design" },
  { key: "email", angle: -30, icon: emailMarketing, alt: "Email Marketing" },
  { key: "pr", angle: 0, icon: onlinePR, alt: "Online PR" },
  { key: "social", angle: 30, icon: socialMedia, alt: "Social Media" },
  { key: "blog", angle: 60, icon: blogging, alt: "Blogging" },
  { key: "media", angle: 90, icon: multimedia, alt: "Multimedia" },
  { key: "ppc", angle: 120, icon: ppc, alt: "Pay Per Click Ads" },
  { key: "display", angle: 150, icon: displayAds, alt: "Display Ads" },
  { key: "content", angle: 180, icon: webContent, alt: "Web Content" },
  { key: "security", angle: 210, icon: cyberSecurity, alt: "Cyber Security" },
  { key: "ai", angle: 240, icon: aiIntegration, alt: "AI Integration" },
];

function getTimeInZone(timeZone) {
  const now = new Date();
  const zoned = new Date(now.toLocaleString("en-US", { timeZone }));

  return {
    hours: zoned.getHours(),
    minutes: zoned.getMinutes(),
    seconds: zoned.getSeconds(),
    milliseconds: zoned.getMilliseconds(),
  };
}

export default function AnalogClock() {
  const [, forceRender] = useState(0);

  useEffect(() => {
    const t = setInterval(() => forceRender((v) => v + 1), 250);
    return () => clearInterval(t);
  }, []);

  // 🇺🇸 Change timezone here
  const TIME_ZONE = "America/New_York";

  const { hours, minutes, seconds, milliseconds } = getTimeInZone(TIME_ZONE);

  const sec = seconds + milliseconds / 1000;
  const min = minutes + sec / 60;
  const hour = (hours % 12) + min / 60;

  const secDeg = sec * 6;
  const minDeg = min * 6;
  const hourDeg = hour * 30;

  return (
    <div className="clock-stage">
      <div className="services-ring" aria-hidden="true">
        {SERVICES.map((item) => (
          <div
            key={item.key}
            className="service-item"
            style={{ "--a": `${item.angle}deg` }}
          >
            <div className="service-icon">
              <img src={item.icon} alt={item.alt} draggable="false" />
            </div>
          </div>
        ))}
      </div>

      <div className="clock-face" aria-label="Analog clock">
        <div className="clock-center" />

        <div
          className="hand hour"
          style={{ transform: `translate(-50%, -100%) rotate(${hourDeg}deg)` }}
        />
        <div
          className="hand minute"
          style={{ transform: `translate(-50%, -100%) rotate(${minDeg}deg)` }}
        />
        <div
          className="hand second"
          style={{ transform: `translate(-50%, -100%) rotate(${secDeg}deg)` }}
        />
      </div>
    </div>
  );
}
